<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-04-19 14:37:18
 * @LastEditTime: 2019-04-19 14:37:18
 * @LastEditors: 长老
 -->
<template>
  <div class="top-meta-view top-bar border-bottom-1px" :class="{rightPadding: !showSearch}">
    <div class="commodity-back-btn back-btn iconfont icon-left-arrow" @click="lastPage"></div>
    <div class="commodity-title view-title">{{titleName}}</div>
    <div v-if="showSearch" class="commodity-search-btn search-btn iconfont icon-search" @click="toSearchPage"></div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import YunJi from '@/assets/js/YunJi'
const { mapState, mapActions } = createNamespacedHelpers('categoryNav')

export default {
  props: {
    titleName: {
      type: String
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    shopId:{
      type:String,
      default(){
        return '0'
      }
    }
  },
  data() {
    return {
      isApp: YunJi.isApp()
    }
  },
  methods: {
    toSearchPage() {
      if(this.isApp) {
        location.href = `yunji://common/searchList`
      }else{
        location.href = `//${globalConfig.linkBasePath}/yjbuyer/search-list?shopId=${this.shopId}&appCont=${this.appCont}&isCategory=0`;
      }
    },
    lastPage() {
      this.$emit('lastPage')
    }
  },
  computed: {
    ...mapState({
      appCont: state => state.appCont
    })
  }
};
</script>

<style lang="less" scoped>
@import '../../commodity/style/common.less';
.top-meta-view{
  &::before{
    border-top-color: #ddd;
  }
  &.rightPadding{
    padding-right: 1rem;
  }
}
</style>